import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    member: PropTypes.object.isRequired,
  },
  render() {
    let is_active_by_event_participated = "";
    let is_active_by_viewed = "";
    if (this.props.member.is_active_by_event_participated) {
      // is_active_by_event_participated = <Ribbon type='is_active_by_event_participated' />;
      is_active_by_event_participated = "アクティブイベンター";
    }
    if (this.props.member.is_active_by_viewed) {
      // is_active_by_viewed = <Ribbon type='is_active_by_viewed' />;
      is_active_by_viewed = "アクティブビュワー";
    }
    return (
      <span className="flex">
        {is_active_by_event_participated}
        {is_active_by_viewed}
      </span>
    );
  },
});
